import { Button, Divider, Skeleton } from '@heroui/react';
import { Icon } from '@iconify/react';

export type ILocationsItemProps = {
  name?: string;
  value?: string;
  isLoading?: boolean;
};

export type ILocationsListProps = {
  items?: (ILocationsItemProps | undefined)[];
  onSelect?: (key: string) => void;
  value?: string;
  className?: string;
  isDivided?: boolean;
};

export const LocationsList = ({
  items = [],
  onSelect,
  value,
  className = '',
  isDivided = false,
}: ILocationsListProps) => {
  return (
    <div className={className}>
      {items?.map((item, index) => (
        <div key={index}>
          <Skeleton isLoaded={!item?.isLoading}>
            <Button
              fullWidth
              variant="light"
              size="lg"
              color="primary"
              className="px-0 lg:px-2"
              onPress={() => onSelect?.(item?.value || '')}
            >
              <div className="flex flex-row justify-between items-center w-full">
                <p className="text-sm text-[#222222]">{item?.name}</p>
                <div>
                  {value === item?.value && (
                    <Icon width={24} height={24} icon="si:check-duotone" />
                  )}
                </div>
              </div>
            </Button>
          </Skeleton>

          {index + 1 !== items?.length && isDivided && <Divider />}
        </div>
      ))}
    </div>
  );
};
